import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Injectable()

export class AuthenticationInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.authService.get_token();
        req = req.clone({
            setHeaders: {
                Authorization: 'Bearer ' + authToken,
            },
        });
        return next.handle(req);
    }
}
